export enum Permission {
  Unspecified = 0,
  Allowed = 1,
  Denied = 2,
  Mixed = 3
}

// larger reasons take precedence
export enum PermissionReason {
  Unspecified = 0,
  ImplicitDeny = 1,
  GroupAllow = 2,
  GroupDeny = 3,
  UserAllow = 4,
  UserDeny = 5,
  DerivedAllow = 6,
  UserLicensingDeny = 7,
  GuestAllow = 8,
  UserAuthorizableOwnerAllow = 9,
  GroupProjectLeaderAllow = 10,
  UserProjectLeaderAllow = 11,
  UserProjectOwnerAllow = 12,
  UserAdminAllow = 13,
  Mixed = 14,
}

export interface IPermission {
  permission: Permission;
  reason: PermissionReason;
}
